import React from "react";
import { Box, Container, Typography } from "@mui/material";

const PageTitle = ({ pageTitle, pagesub }) => {
  const themeColors = {
    primary: "#0c265a",
    secondary: "var(--secondary-color)",
    textGray: "#687693",
    lightBg: "#f8fbff",
    white: "#fff"
  };

  return (
    <Box sx={{ 
      bgcolor: themeColors.primary, 
      pt: { xs: 20, md: 28 }, 
      pb: { xs: 12, md: 15 }, 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: { xs: '300px', md: '400px' },
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <Box sx={{ 
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.05) 0%, transparent 50%)",
        zIndex: 0
      }} />
      <Container sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h2" sx={{ 
          color: '#fff', 
          fontWeight: 800, 
          fontSize: { xs: '2rem', md: '3rem' },
          fontFamily: "'Roboto Slab', serif",
        }}>
          {pageTitle}
        </Typography>
        {pagesub && (
          <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem', maxWidth: '700px', mx: 'auto', mt: '10px' }}>
            {pagesub}
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default PageTitle;
